import { Routes } from '@angular/router';

export const usersRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        loadComponent: () => import('@app/admin/users/overview/overview.component').then(component => component.OverviewComponent),
      },
    ],
  },
  {
    path: ':id',
    children: [
      {
        path: '',
        loadComponent: () => import('@app/admin/users/details/details.component').then(component => component.DetailsComponent),
      },
    ],
  },
];
